import GetFTR from '../../getFTR/js/getFTR';

(function () {
    var $body = $('body');

    var tab = {
        $target: null,
        $toggle: null,
        $li: null,
        $spinner: null,
        $ul: $('.tab__nav'),
        $previous: null,
        $content: null,
        isTouched: false,
        extraMargin: 25,
        elementvPort: null,
        $controls: null,
        pointerPosition: 0.0,
        cumulativeShift: 0.0,
        vPort: 'screen-sm', // default responsive break point
        isSlide: false,
        isMobile: [], // variable use to determine if responsive mode is on or off
        backToAccessibility: true, // variable use to determine if we want to add back btn to navigate between content and aside
        swipeDisableClass: 'arrows-slide__single--disabled',
        article: null,
        isGetFTREnabled: false,
        isGetFTRReferencesEnabled: false,
        isGetFTRCitedByEnabled: false,
        tabSelector: '.tab__nav a',

        init: function () {
            tab.$spinner = $('.tab__spinner');
            tab.preselectTab();
            tab.elementvPort = tab.vPort;
            tab.vPort = [];
            tab.article = document.querySelector('article');
            tab.isGetFTREnabled = tab.article?.getAttribute('data-getFTR-enabled');
            tab.isGetFTRReferencesEnabled = tab.article?.getAttribute('data-getFTR-references-enabled');
            tab.isGetFTRCitedByEnabled = tab.article?.getAttribute('data-getFTR-citedBy-enabled');
            const tabElm = $('.tab:not(.tab .tab)'); // in case hierarchical tabs, which is looping inside nested tabs that have the same main tab behavior ex: loi
            let eleWithLabelsData;
            tabElm.each((index, ele) => {
                if (ele.getAttribute('data-prev-text')) {
                    eleWithLabelsData = $(ele);
                    return false;
                }
            });
            tabElm.each(function (index) {
                const _this = $(this);
                tab.check.viewPort(index, _this); // get current view port activator break point
                tab.responsive(index, _this);
            });
            tab.$controls = `
                <div class='arrows-slide' role='presentation'>
                    <button role='tab' class='arrowed-button icon-arrow_l arrows-slide__single prev'
                        ${eleWithLabelsData ? `data-prev-text="${eleWithLabelsData.attr('data-prev-text')}"` : ''}
                        ${eleWithLabelsData ? `data-no-prev-text="${eleWithLabelsData.attr('data-no-prev-text')}"` : ''}
                    ></button>
                    <button role='tab' class='arrowed-button icon-arrow_r arrows-slide__single next'
                        ${eleWithLabelsData ? `data-next-text="${eleWithLabelsData.attr('data-next-text')}"` : ''}
                        ${eleWithLabelsData ? `data-no-next-text="${eleWithLabelsData.attr('data-no-next-text')}"` : ''}
                    ></button>
                </div>
                `;
            tab.on.build();
            tab.control();
            $(tab.tabSelector).each(function () {
                // go through all tab nav items
                tab.check.empty($(this));
            });
        },

        preselectTab: function () {
            // The preselectTab function should be cleanup
            // Its better to use query string in url instead session storage for select active tab
            // We should depend on data-target always instead of href because href may contain url not tab-pane selector
            // selection of active tab should tested on nested tabs and multi tabs on page

            $('.tab').each(function () {
                //the rest of this code doesnt seem to support multiple tabs on the page.. but this does
                const _this = $(this);

                if (_this.data('js-preselect') === false)
                    //If you don't need js to select the active tab
                    return true;

                const $activeTab = _this.find('.tab__nav').find('li.active a');
                let activeTab = tab.getPaneTarget($activeTab);
                let sessionActiveTab = null;

                if (!activeTab && sessionStorage.activeTab) {
                    // check "sessionStorage.activeTab" is solution for LIT-189292
                    activeTab = sessionStorage.getItem('activeTab');
                    sessionActiveTab = activeTab;
                }

                // Checking if activeTab contains hash, if not it is not 'tab'
                const hash = activeTab ? activeTab.match(/#/) : null;
                if (activeTab && (!hash || hash.index !== 0)) return;

                if (_this.find(activeTab).length === 0) {
                    activeTab = null;
                } else if (sessionActiveTab) {
                    sessionStorage.setItem('activeTab', '');
                }

                if (location.search !== '') {
                    const reExp = /activeTab=\b[\w-]+$/g;

                    if (reExp.test(location.search)) {
                        const activeParameter = location.search.match(reExp)[0];
                        if ($('#' + activeParameter.split('=')[1]).length) {
                            activeTab = '#' + activeParameter.split('=')[1];
                        }
                    }
                }

                let $firstItem = _this.find('.tab__nav').find('li:first-of-type [data-toggle]');
                if (!activeTab) activeTab = tab.getPaneTarget($firstItem);

                if ((activeTab && activeTab.split('#').length < 2) || activeTab === '') return true;

                const triggerTarget = $("[data-target='" + activeTab + "'], [href='" + activeTab + "']");
                tab.autoTabActivation(triggerTarget, activeTab, _this);
            });
        },

        autoTabActivation: function (triggerTarget, activeTab, _this) {
            if (!triggerTarget.closest('.w-slide__btn').length) {
                // @TODO add condition to apply on while on mobile only, think: is the closest() method really best for the job?
                triggerTarget.click();
                _this.find(activeTab).addClass('active'); // in some cases to display tab content the .active class has to tiggered. Known case: alerts management in profile, when directed to a specific tab.
            }
        },

        control: function () {
            $body.on('click', '.tab-link', function (e) {
                e.preventDefault();
                const $this = $(this),
                    documentScrollTop = $(document).scrollTop();

                $this.attr('data-scroll-back-to', documentScrollTop);
                tab.triggerExternal($this);
            });
            if (config.enableTabsTypeDropdown) {
                $body.on('click', '[data-mobile-toggle="dropdown"] a, .dropblock--tab a', function (e) {
                    tab.on.select.dropdown($(this));

                    if ($('.js--open[data-db-target-for]').length) UX.dropBlock.on.hide();
                });
            }
            $body.on('click', tab.tabSelector, function () {
                const _this = $(this);
                const tabId = tab.getPaneTarget(_this);
                $(document).trigger('tabs:changeActiveTab', {tabId: tabId});
                const $parent = _this.parents('.tab');
                if ($parent.hasClass('tab--lazy-load')) {
                    if ($(tabId).attr('data-ajaxloaded') !== 'true') {
                        tab.getContent($(tabId).find('.tab-lazy'));
                    }
                }

                if (tab.isGetFTREnabled) {
                    const getFTR = UX.getFTR || new GetFTR();
                    if (tab.isGetFTRReferencesEnabled && _this[0].classList.contains('references-tab')) {
                        getFTR.referencesTab();
                    } else if (tab.isGetFTRCitedByEnabled && _this[0].classList.contains('related-tab')) {
                        getFTR.relatedTab();
                    }
                }
            });
            if (config.enableTabsTypeSwipeList) {
                $body.on('click touchend keydown', '.arrows-slide .next', function (e) {
                    if (e.key && e.key !== 'Enter') return;
                    if ($(this).hasClass(tab.swipeDisableClass)) return;
                    e.preventDefault();
                    let $activeNav = $(this).closest('.tab__nav').find('.active');
                    let $activePane = $(this).closest('.tab').find('.tab__content .tab__pane.active');
                    if ($activeNav.next().not('.arrows-slide').length > 0) {
                        const $newActiveEl = $activeNav.removeClass('active').next().not('.arrows-slide');
                        $newActiveEl.addClass('active').show();
                        $activePane.removeClass('active').next().addClass('active');
                        tab.navToExternal($newActiveEl);
                        let tabbedText = $newActiveEl.text();
                        tab.toggleArrowAttrs(
                            $(this).closest('.arrows-slide').find('.next'),
                            false,
                            'data-next-text',
                            tabbedText
                        );
                        if (!$activeNav.next().not('.arrows-slide').next().not('.arrows-slide').length) {
                            tab.toggleArrowAttrs($(this), true, 'data-no-next-text', tabbedText);
                        }
                        tab.toggleArrowAttrs(
                            $(this).closest('.arrows-slide').find('.prev'),
                            false,
                            'data-prev-text',
                            tabbedText
                        );
                    }
                });

                $body.on('click touchend keydown', '.arrows-slide .prev', function (e) {
                    if (e.key && e.key !== 'Enter') return;
                    if ($(this).hasClass(tab.swipeDisableClass)) return;
                    e.preventDefault();
                    let $activeNav = $(this).closest('.tab__nav').find('.active');
                    let $activePane = $(this).closest('.tab').find('.tab__content .tab__pane.active');
                    if ($activeNav.prev().not('.arrows-slide').length > 0) {
                        const $newActiveEl = $activeNav.removeClass('active').prev().not('.arrows-slide');
                        $newActiveEl.addClass('active').show();
                        $activePane.removeClass('active').prev().addClass('active');
                        tab.navToExternal($newActiveEl);
                        let tabbedText = $newActiveEl.text();
                        tab.toggleArrowAttrs(
                            $(this).closest('.arrows-slide').find('.prev'),
                            false,
                            'data-prev-text',
                            tabbedText
                        );
                        if (!$activeNav.prev().not('.arrows-slide').prev().not('.arrows-slide').length) {
                            tab.toggleArrowAttrs($(this), true, 'data-no-prev-text', tabbedText);
                        }
                        tab.toggleArrowAttrs(
                            $(this).closest('.arrows-slide').find('.next'),
                            false,
                            'data-next-text',
                            tabbedText
                        );
                    }
                });
            }
            // Get postback active tab
            tab.setPostbackActiveTab(tab.getPostbackActiveTab());
            tab.arrowsNavigation();
            tab.additionalControl();
        },
        toggleArrowAttrs: function ($ele, isDisabled = true, attrStr, currentLabel) {
            $ele.toggleClass(tab.swipeDisableClass, isDisabled)
                .attr('aria-label', currentLabel + ' ' + $ele.attr(attrStr))
                .attr('aria-disabled', isDisabled);
        },
        additionalControl: function () {},
        navToExternal($activeNav) {
            const $externalLink = $activeNav.find('.external');
            if ($externalLink.length) {
                window.location.href = $externalLink.attr('href');
            }
        },
        arrowsNavigation: function () {
            const tabs = [...$(this).closest('.tab__nav')];

            if (!tabs.length) return;
            tabs.forEach((tab, index) => {
                tab.addEventListener('keydown', e => {
                    let newIndex;

                    if (e.key === 'ArrowRight') {
                        e.preventDefault(); // Prevent moving cursor in button text
                        newIndex = (index + 1) % tabs.length;
                    } else if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        newIndex = (index - 1 + tabs.length) % tabs.length;
                    }

                    if (newIndex !== undefined) {
                        tabs.forEach(t => t.setAttribute('tabindex', '-1')); // remove tab focus from all
                        tabs[newIndex].setAttribute('tabindex', '0');
                        tabs[newIndex].focus();
                    }
                });
            });
        },
        responsive: function (index, tabElem) {
            $(document).on(tab.vPort[index] + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                tab.isMobile[index] = true;
                //$('[data-slide-target]').addClass('w-slide__btn');

                // $('.tab').each(function () {
                if (tabElem.data('ctrl-res') === tab.vPort[index]) {
                    tabElem.addClass('tab--res'); // class will be used in our scss (to replace media queries)
                    tab.additionalControl();
                    tab.on.rebuild.responsive(tabElem); // rebuild tabs to be responsive
                }
                // });

                // withArrows.each(function (i, o) {
                if (tabElem.closest('.swipe-with-arrows').length) {
                    const tabNav = tabElem.find('.tab__nav');
                    if (tabNav.children('li').length > 1) {
                        const posIndex = tabNav.children('li.active').index(),
                            length = tabNav.children('li').length,
                            controls = $(tab.$controls);
                        tabNav.children('li:not(.active)').hide();
                        let currentLabel = tabNav.children('li.active').text();
                        if (posIndex + 1 === length) {
                            // decide which arrow to disable
                            tab.toggleArrowAttrs(controls.find('.next'), true, 'data-no-next-text', currentLabel);
                            tab.toggleArrowAttrs(controls.find('.prev'), false, 'data-prev-text', currentLabel);
                        }
                        if (posIndex === 0) {
                            tab.toggleArrowAttrs(controls.find('.prev'), true, 'data-no-prev-text', currentLabel);
                            tab.toggleArrowAttrs(controls.find('.next'), false, 'data-next-text', currentLabel);
                        }
                        tabNav.append(controls);
                    }
                }
                // });
            });

            $(document).on(tab.vPort[index] + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                tab.isMobile[index] = false;

                // $('.tab').each(function () {
                if (tabElem.data('ctrl-res') === tab.vPort[index]) {
                    tabElem.removeClass('tab--res'); // class will be used in our scss (to replace media queries)
                    tab.on.rebuild.original($(this)); // return tabs as default
                }
                // });

                const withArrows = $('.swipe-with-arrows').find('.tab__nav');
                withArrows.children('li').css('display', 'inline-block');
                withArrows.find('.arrows-slide').remove();
            });
        },
        animate: {
            scroll: function ($content, $target) {
                if ($target.length) {
                    const contentScrollTop = $content.scrollTop();
                    const contentTop = $content.position().top;
                    const targetTop = $target.position().top;
                    $content.animate(
                        {
                            scrollTop: targetTop - contentTop + contentScrollTop,
                        },
                        600
                    );
                }
            },
        },
        set: {
            target: function ($content, target, temp) {
                if (!$content.find(target).length) {
                    tab.$target = $content.find("[data-figure-id='" + temp + "']");
                } else {
                    tab.$target = $content.find(target);
                }
            },
        },
        accessibility: {
            /**
             * Accessibility - navigate between content and aside
             * @param elem
             * @param tab
             */
            externalLink: function (elem, tab) {
                // create focusable option for target
                const tabindex = tab.$target.attr('tabindex');
                tab.$target.attr('tabindex', typeof tabindex === 'undefined' ? -1 : tabindex);
                // create and append back button to content
                const backLink = $('<button class="btn btn--keyboard-accessible">Go back to content</button>');
                if (tab.backToAccessibility) {
                    if (tab.$target.is('a, ul, ol, img, table') || tab.$target.is(':input')) {
                        tab.$target.after(backLink);
                    } else {
                        tab.$target.append(backLink);
                    }

                    // go back to original element if backbutton is activated
                    backLink
                        .on('click', function () {
                            elem.focus();
                        })
                        .on('focusout', function () {
                            $(this).remove();
                        });
                }
                // revert original state on focus out
                tab.$target
                    .on('focusout.tablink', function (event) {
                        const $this = $(this);
                        // revert tabindex to original value
                        if (typeof tabindex === 'undefined') {
                            $this.removeAttr('tabindex');
                        }
                        // remove backbutton if user tabbed out of target by some other means than tabbing to backlink
                        if (
                            !$(event.relatedTarget).is(backLink) &&
                            !$(event.relatedTarget).parents().filter(tab.$target).length
                        ) {
                            if (backLink.length) backLink.remove();
                            $this.off('focusout.tablink');
                        }
                    })
                    // provide ESC support for return to content
                    .on('keydown.tablink', function (event) {
                        const $this = $(this);
                        // on escape, return to control
                        if (event.which === 27) {
                            $this.off('keydown.tablink');
                            elem.focus();
                            if (backLink.length) backLink.remove();
                        }
                    });

                // set focus to target
                tab.$target.focus();
            },
        },
        on: {
            select: {
                external: function ($elem) {
                    var target = $elem.attr('href'); // get target id

                    target = target.split(' ')[0]; //LIT-162636

                    tab.$toggle = '#' + $elem.data('tab'); //get target pane
                    tab.$li = $('.tab__nav [href="' + tab.$toggle + '"]'); // get target tabs nav
                    const temp = target.split('#')[1];
                    const parentTab = $(tab.$toggle).closest('.tab');
                    const animateScroll = function () {
                        tab.$content = $(tab.$toggle).parents('.tab__content');
                        if (!tab.$content.length && $elem.is('[data-slide-target]') && $elem.hasClass('slide-active'))
                            tab.$content = $('.w-slide__content');

                        if (parentTab.hasClass('tab--res')) {
                            tab.isSlide = parentTab.hasClass('tab--slide');
                            if (tab.isSlide) {
                                tab.set.target($('.w-slide__content'), target, temp);
                                if (tab.$target.length) {
                                    tab.animate.scroll($('.w-slide__content'), tab.$target);
                                    tab.$target.attr('tab-index', '1');
                                    tab.$target.focus();
                                }
                            }
                        } else {
                            tab.set.target(tab.$content, target, temp);
                            tab.animate.scroll(tab.$content, tab.$target);
                            tab.accessibility.externalLink($elem, tab);
                        }
                    };

                    if ($(tab.$toggle).is(':visible')) {
                        tab.$li.click(); // open target tab
                        animateScroll();
                    } else {
                        if ($(tab.$toggle).hasClass('empty')) {
                            $(tab.$toggle).on('content-loaded', function () {
                                animateScroll();
                            });
                            tab.$li.click(); // open target tab
                        } else {
                            tab.$li.click(); // open target tab
                            animateScroll();
                        }
                    }
                },
            },
            build: function () {
                //setTimeout(function() {
                tab.$ul.each(function (index) {
                    if ($(this).is('.swipe__list') && config.enableTabsTypeSwipeList) {
                        tab.on.swipeBuild($(this));
                    }
                    if ($(this).is('.dropblock--tab') && config.enableTabsTypeDropdown) {
                        tab.on.dropdownBuild($(this), index);
                    }
                });
                //}, 200);
                $('.tab--lazy-load').each(function () {
                    tab.getContent($(this).find('.tab__pane.active').find('.tab-lazy'));
                });
            },
            // calculate: function (elem) {
            //     var elemParent = elem.parent();
            //     var tabNavWidth = tab.extraMargin;
            //     elem.find('li').each(function (index) {
            //         tabNavWidth += $(this).innerWidth();
            //     });
            //     var elemParentWidth = elemParent.width();
            //     if (elemParentWidth < tabNavWidth) {
            //         if (!elem.parent().is('.scroll')) {
            //             tab.on.swipeBuild(elem, tabNavWidth);
            //         }
            //     } else {
            //         tab.on.swipeDestroy(elem);
            //     }

            // },

            slideDestroy: function (elem) {
                elem.find('[data-slide-target]').removeClass('w-slide__btn slide-active');
            },
            rebuild: {
                original: function ($elem) {
                    // return tabs to be as default
                    //$('[data-slide-target]').removeClass('w-slide__btn slide-active');
                    tab.$ul = $elem.find('.tab__nav');
                    tab.$ul.each(function (index) {
                        switch (
                            $(this).data('mobile-toggle') ||
                            $(this).closest('[data-mobile-toggle]').data('mobile-toggle')
                        ) {
                            case 'swipe':
                                if (config.enableTabsTypeSwipeList) tab.on.swipeDestroy($(this));
                                break;
                            case 'dropdown':
                                if (config.enableTabsTypeDropdown) tab.on.dropdownDestroy($(this));
                                break;
                            case 'accordion':
                                if (config.enableTabsTypeAccordion);
                                tab.on.accordionDestroy($(this));
                                break;
                            case 'slide':
                                tab.on.slideDestroy($(this));
                                break;
                            default:
                            /*if ( $(this).closest('.tab').hasClass('tab--flex') ||  $(this).closest('.tab').hasClass('loi') ||  $(this).hasClass('dropblock--tab') || $(this).closest(".advancedSearch__tabs").length ) {
                                return;
                            }else {
                                tab.on.calculate($(this));
                            }
*/
                        }
                    });
                    $(document).trigger('init.bs.tab');
                },
                responsive: function ($elem) {
                    // rebuild tabs to be in selected responsive mode
                    tab.$ul = $elem.find('.tab__nav');
                    $('.tab__nav').find('[data-slide-target]').addClass('w-slide__btn slide-active');

                    tab.$ul.each(function (index) {
                        switch (
                            $(this).data('mobile-toggle') ||
                            $(this).closest('[data-mobile-toggle]').data('mobile-toggle')
                        ) {
                            case 'swipe': // rebuild tabs to swipe
                                if (!$(this).parent().is('.scroll') && config.enableTabsTypeSwipeList) {
                                    tab.on.swipeBuild($(this));
                                }
                                break;
                            case 'dropdown': // rebuild tabs be as dropdown
                                if (!$(this).parent().is('.dropBlock') && config.enableTabsTypeDropdown) {
                                    tab.on.dropdownBuild($(this), index);
                                }
                                break;
                            case 'accordion': // rebuild tabs be as accordion
                                if (!$(this).next().hasClass('accordion') && config.enableTabsTypeAccordion) {
                                    tab.on.accordionBuild($(this));
                                }
                                break;
                            case 'slide': // rebuild tabs be as accordion
                                break;
                            default: // rebuild tabs to flex
                            /*if ( $(this).closest('.tab').hasClass('tab--flex') ||  $(this).closest('.tab').hasClass('loi') ||  $(this).hasClass('dropblock--tab') || $(this).closest(".advancedSearch__tabs").length  ) {
                                return;
                            }else {
                                tab.on.calculate($(this));
                            }*/
                        }
                    });
                    $(document).trigger('init.bs.tab');
                },
            },
        },
        check: {
            empty: function ($tabItem) {
                // check if tab pane is empty and hide it
                let pane = tab.getPaneTarget($tabItem); // get it's related pane

                if ($tabItem.is('a:not([href^="#"])') || $tabItem.hasClass('external'))
                    // it is link and has no pane
                    return;

                if (!$(pane).length) {
                    $tabItem.addClass('empty'); // disable tab nav because it has no pane
                }
                let $pane = $(pane),
                    hasNoContent = !$pane.text().trim().length || $pane.find('.emptyTab').length || $pane.is(':empty');

                if ($pane.length && hasNoContent) {
                    // if tab nav item is not an external link and check if pane is empty
                    $pane.addClass('empty'); // add class to empty pane
                    $tabItem.addClass('empty'); // add class to empty nav item
                    if ($pane.is('#pane-pcw-related')) {
                        let emptyText = $pane.data('empty-text');
                        $pane.append(`<div class="is-empty">${emptyText}</div>`);
                        if ($pane.find('.show-recommended-placeholder').length) {
                            $(document).on('showRecommended:loaded', () => {
                                $pane.find('.is-empty').remove();
                                $pane.removeClass('empty');
                                $tabItem.removeClass('empty');
                            });
                        }
                    }
                    return true; // abort
                } else {
                    $pane.removeClass('empty'); // add class to empty pane
                    $pane.find('.is-empty').remove();
                    $tabItem.removeClass('empty'); // add class to empty nav item
                    return false; // abort
                }
            },
            viewPort: function (index, $el) {
                if (typeof $el.data('ctrl-res') != 'undefined' || $el.data('ctrl-res') === '') {
                    tab.vPort[index] = $el.data('ctrl-res');
                } else {
                    $el.data('ctrl-res', tab.elementvPort);
                    tab.vPort[index] = tab.elementvPort;
                }
            },
        },
        triggerExternal($el) {
            tab.on.select.external($el);
        },
        getPaneTarget: function ($elem) {
            return $elem.data('target') || $elem.attr('href');
        },
        getPostbackActiveTab: function () {
            let param = 'tabActivePane';
            param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); /*eslint-disable-line*/
            const regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
            const results = regex.exec(location.search);
            return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        setPostbackActiveTab: function (tabID) {
            if (tabID !== '') {
                const $activeTabs = $("a[data-simple-tab-id='" + tabID + "']");

                if ($activeTabs.length > 0) {
                    $activeTabs.each(function () {
                        $activeTabs.trigger('click');
                    });
                }
            }
        },
        additionalAjaxSuccess: function (data) {},
        getContent: function ($elem) {
            var tabId = $elem.attr('data-tabId');
            var widgetId = $elem.attr('data-widgetId');
            var pbContext = encodeURIComponent($('meta[name=pbContext]').attr('content'));
            var $tabBody = $elem.parents('.tab__pane');
            $.ajax({
                url:
                    '/pb/widgets/ux3/lazyTabs/loadTab?pbContext=' +
                    pbContext +
                    '&tabId=' +
                    tabId +
                    '&widgetId=' +
                    widgetId,
                success: function (data) {
                    $tabBody.attr('data-ajaxLoaded', 'true');
                    $elem.replaceWith(data);
                    if ($tabBody.find('.tab__pane.active').find('.tab-lazy').length) {
                        tab.getContent($tabBody.find('.tab__pane.active').find('.tab-lazy'));
                    }
                    $tabBody.find('>.tab__spinner').hide();
                    // we did not use $(data).find() because the data is not a DOMElement thus,
                    // any logic will be added .js-showcase-slideshow within the data not within DOM,
                    // we need to get the element from the DOM that's
                    tab.showcaseSlideshowCheck($tabBody.find('.js-showcase-slideshow'));
                    tab.additionalAjaxSuccess(data);
                },
                error: function () {},
            });
        },
        showcaseSlideshowCheck($showCase) {
            if (!$showCase.length || !UX.showcaseSlideshow) {
                return;
            }
            UX.showcaseSlideshow.initInstance($showCase, UX.showcaseSlideshow.defaultOptions);
        },
    };

    if (config.enableTabsTypeDropdown) {
        tab.on.select.dropdown = function (elem) {
            const dataAttr = elem.closest('ul').data('mobile-toggle');
            if (dataAttr === 'dropdown' || elem.closest('ul').hasClass('dropblock--tab')) {
                const dropdownContainer = elem.closest('.dropBlock');
                dropdownContainer.children('.dropBlock__link').find('span').text(elem.text());
            }
        };
        tab.on.dropdownBuild = function (elem, index) {
            // rebuild tabs to be as drop down
            if (UX.dropBlock) {
                UX.dropBlock.init();
            }

            elem.wrap('<div class="dropBlock" data-db-parent-of="dbTab-' + index + '"></div>');
            const $dropdownContainer = elem.closest('.dropBlock');
            const $activeTab = elem.find('.active a');
            const optionCount = elem.find('>li').length;
            let toggleElement = '';

            if (optionCount === 1) {
                // Only one option: use non-interactive span with role="presentation"
                toggleElement =
                    '<span role="presentation" class="dropBlock__link">' +
                    '<span>' +
                    $activeTab.text() +
                    '</span></span>';
                elem.hide();
            } else {
                toggleElement =
                    '<button type="button" aria-expanded="false" class="dropBlock__link" data-db-target-for="dbTab-' +
                    index +
                    '"><span>' +
                    $activeTab.text() +
                    '</span><i class="icon-arrow_d_n" aria-hidden="true"></i></button>';
                elem.attr('data-db-target-of', 'dbTab-' + index);
            }
            $dropdownContainer.prepend(toggleElement);
        };
        tab.on.dropdownDestroy = function (elem) {
            // return tabs to default
            const dropdownContainer = elem.closest('.dropBlock');
            dropdownContainer.children('.dropBlock__link').remove();
            elem.removeAttr('data-db-target-of').removeClass('js--open').removeAttr('style').unwrap('.dropBlock');
        };
    }

    if (config.enableTabsTypeSwipeList) {
        tab.on.swipeBuild = function (elem, tabNavWidth) {
            // rebuild tabs to swipe
            elem.wrap('<div class="swipe__wrapper"><div class="scroll"></div></div>');

            if (!tabNavWidth) {
                tabNavWidth = tab.extraMargin;
                elem.closest('.tab__pane').css('display', 'block');
                elem.find('li').each(function (index) {
                    tabNavWidth += $(this).innerWidth();
                });
                elem.closest('.tab__pane').css('display', '');
            }

            elem.width(tabNavWidth);
        };

        tab.on.swipeDestroy = function (elem) {
            // return tabs to default

            elem.removeAttr('style');
            elem.unwrap('.scroll').unwrap('.swipe__wrapper');
        };
    }

    if (config.enableTabsTypeAccordion) {
        tab.on.accordionBuild = function (elem) {
            // rebuild tabs to be as accordion

            const $accourdionElem = elem.next('.tab__content');
            $accourdionElem.addClass('accordion-tabbed').wrap('<div class="accordion"></div>');

            elem.find('a').each(function (index) {
                const $lidiv = $(this);
                const liController = tab.getPaneTarget($lidiv);

                $(liController)
                    .addClass('accordion-tabbed__tab') // transform tabs structure to accordion structure
                    .removeClass('tab__pane')
                    .wrapInner('<div class="accordion-tabbed__content"></div>');
                $lidiv.clone().prependTo(liController).addClass('accordion-tabbed__control'); // clone tabs controller as accordion controller
            });

            elem.hide();
            UX.accordion.init();

            $('.tab__content.accordion-tabbed .accordion-tabbed__tab')
                .removeClass('js--open')
                .find('.accordion-tabbed__content')
                .hide();
            $('.tab__content.accordion-tabbed .accordion-tabbed__tab.active')
                .addClass('js--open')
                .find('.accordion-tabbed__content')
                .show();
        };

        tab.on.accordionDestroy = function (elem) {
            // return tabs to default
            elem.next('.accordion')
                .find('.tab__content')
                .removeClass('accordion-tabbed')
                .unwrap('.accordion')
                .find('.accordion-tabbed__tab')
                .each(function (index) {
                    const $liDiv = $(this);
                    $liDiv.addClass('tab__pane').removeClass('accordion-tabbed__tab js--open');
                    const content = $liDiv.find('.accordion-tabbed__content').text();
                    $liDiv.html(content);
                    elem.show();
                });
            const activeTap = elem.next('.tab__content').find('.active').attr('id');

            elem.find('.active').removeClass('active');

            $('[href="#' + activeTap + '"]')
                .closest('li')
                .addClass('active');
        };
    }

    UX.tab = tab; // add to global namespace
})();
